<template>
    <div style="position:relative;">
        <div>
            <table class="logtable">
                <thead>
                    <tr>
                        <th class="rownum"></th>
                        <th>LOG ID</th>
                        <th>タイムスタンプ</th>
                        <th>操作</th>
                        <th>発注ID</th>
                        <th>発注件名</th>
                        <th>発注ステータス</th>
                        <th>発注区分</th>
                        <th>発注書版</th>
                        <th>発注書番号</th>
                        <th>発注先</th>
                        <th>発注担当者</th>
                        <th>発注日</th>
                        <th>納品日</th>
                        <th>支払日</th>
                        <th>発注金額</th>
                        <th>消費税率</th>
                        <th>請求書番号</th>
                        <th>請求書受領区分</th>
                        <th>支払区分</th>
                        <th>発注備考</th>
                        <th>登録アカウント</th>
                        <th>登録日時</th>
                        <th>変更アカウント</th>
                        <th>変更日時</th>
                        <th>Ver.</th>
                    </tr>
                </thead>
                <tbody v-for="(d, ix) in payload_data" :key="d.log_id">
                    <tr>
                        <th class="rownum">
                            {{ ix + 1 }}
                        </th>
                        <td>
                            {{ d.log_id }}
                        </td>
                        <td>
                            {{ d.log_tmsp | datetime }}
                        </td>
                        <td>
                            {{ viewcud(d.cud) }}
                        </td>
                        <td>
                            {{ d.purchaseorder_id }}
                        </td>
                        <td :class="modclass(d, 'purchaseorder_subject')">
                            {{ d.purchaseorder_subject }}
                        </td>
                        <td :class="modclass(d, 'purchaseorder_status')">
                            {{ d.purchaseorder_status }}
                            <span class="stsname">{{
                                viewdiv("posts", d.purchaseorder_status)
                            }}</span>
                        </td>
                        <td :class="modclass(d, 'purchaseorder_div')">
                            <span class="code" v-if="d.purchaseorder_div">{{
                                d.purchaseorder_div
                            }}</span>
                            {{ viewdiv("po", d.purchaseorder_div) }}
                        </td>

                        <td :class="modclass(d, 'order_version')">
                            {{ d.order_version }}
                        </td>
                        <td :class="modclass(d, 'order_number')">
                            {{ d.order_number }}
                        </td>
                        <td :class="modclass(d, 'purchaseorder_customer_id')">
                            <span class="id">{{
                                d.purchaseorder_customer_id
                            }}</span>
                            <span class="code">{{
                                d.purchaseorder_customer_code
                            }}</span>
                            {{ d.purchaseorder_customer_name_short }}
                        </td>
                        <td :class="modclass(d, 'purchaseorder_employee_id')">
                            <span class="code">{{
                                d.purchaseorder_employee_id
                            }}</span>
                            {{ d.purchaseorder_employee_name_long }}
                        </td>
                        <td :class="modclass(d, 'purchaseorder_date', 'date')">
                            {{ d.purchaseorder_date | date }}
                        </td>
                        <td :class="modclass(d, 'delivery_date', 'date')">
                            {{ d.delivery_date | date }}
                        </td>
                        <td :class="modclass(d, 'payment_date', 'date')">
                            {{ d.payment_date | date }}
                        </td>
                        <td
                            :class="[
                                'amount',
                                modclass(d, 'purchaseorder_amount')
                            ]"
                        >
                            {{ d.purchaseorder_amount | amount }}
                        </td>
                        <td :class="['amount', modclass(d, 'tax_rate')]">
                            {{ d.tax_rate }} %
                        </td>
                        <td :class="modclass(d, 'invoice_number')">
                            {{ d.invoice_number }}
                        </td>
                        <td :class="modclass(d, 'invoice_receipt_div')">
                            <span class="code">
                                {{ d.invoice_receipt_div }}</span
                            >
                            {{ viewdiv("invrcpt", d.invoice_receipt_div) }}
                        </td>
                        <td :class="modclass(d, 'payment_div')">
                            <span class="code"> {{ d.payment_div }}</span>
                            {{ viewdiv("pmt", d.payment_div) }}
                        </td>
                        <td :class="modclass(d, 'purchaseorder_note')">
                            {{ d.purchaseorder_note }}
                        </td>
                        <td>
                            {{ d.create_account_id }}
                        </td>
                        <td>
                            {{ d.create_timestamp | datetime }}
                        </td>
                        <td>
                            {{ d.update_account_id }}
                        </td>
                        <td>
                            {{ d.update_timestamp | datetime }}
                        </td>
                        <td>
                            {{ d.row_version }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import LogListMixin from "@/views/LogListMixin.vue";

export default {
    name: "PurchaseorderLogList",
    mixins: [LogListMixin],
    model: {
        prop: "obj"
    },
    props: {
        obj: Object
    },
    data: () => ({
        payload_data: []
    }),
    methods: {
        execute: function() {
            this.payload_data = [];
            let url = "";
            if (this.obj.purchaseorder_id) {
                url = this.makeurl(
                    "log",
                    "po",
                    this.obj.opportunity_id,
                    this.obj.salesorder_id,
                    this.obj.purchaseorder_id
                );
            } else {
                url = this.makeurl(
                    "log",
                    "po",
                    this.obj.opportunity_id,
                    this.obj.salesorder_id
                );
            }
            this.readDataToArray(url, dlist => {
                this.settingPre(dlist, "purchaseorder_id");
                this.payload_data = dlist;
            });
        }
    },
    created: async function() {
        await this.loaddivs("posts", "po", "invrcpt", "pmt");
        this.execute();
    }
};
</script>
